import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from '../assets/WicunaTech_Logo_black.svg';
import { Link, NavLink } from "react-router-dom";
import SignUpForm from "./SignUpForm";

const navLinks = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About Us", end: false },
  { to: "/service", label: "Services", end: false },
  // { to: "/client", label: "Clients", end: false },
  { to: "/contact", label: "Contact Us", end: false },
];

const Navbar = () => {
  const [showModal, setShowModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <>
      <div className="Navbar-Container">
        <div className="Logo-container">
          <Link to="/" className="block">
            <img
              src={Logo}
              alt="Wicuna Technologies"
              className="cursor-pointer w-full h-auto"
            />
          </Link>
        </div>

        {/* Desktop nav - hidden on small screens */}
        <div className="Navbar-pages hidden md:!flex">
          <ul>
            {navLinks.map(({ to, label, end }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  end={end}
                  className={({ isActive }) => isActive ? "nav-link-active" : ""}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* Desktop CTA - hidden on small screens */}
        <div className="Navbar-CTA hidden md:!block">
          <button onClick={() => setShowModal(true)}>Get a Quote</button>
        </div>

        {/* Mobile menu button */}
        <button
          type="button"
          className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          aria-label="Open menu"
          onClick={() => setMobileMenuOpen(true)}
        >
          <Menu className="w-6 h-6" />
        </button>
      </div>

      {/* Mobile menu overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 z-[100] md:hidden"
          aria-hidden="true"
        >
          <div
            className="absolute inset-0 bg-black/50"
            onClick={closeMobileMenu}
          />
          <div className="absolute left-0 top-0 bottom-0 w-full max-w-[280px] bg-white shadow-xl flex flex-col">
            <div className="flex items-center justify-between p-4 border-b">
              <span className="font-semibold text-gray-900">Menu</span>
              <button
                type="button"
                className="p-2 rounded-lg text-gray-600 hover:bg-gray-100"
                aria-label="Close menu"
                onClick={closeMobileMenu}
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <nav className="flex-1 overflow-y-auto py-4">
              <ul className="flex flex-col">
                {navLinks.map(({ to, label, end }) => (
                  <li key={to}>
                    <NavLink
                      to={to}
                      end={end}
                      onClick={closeMobileMenu}
                      className={({ isActive }) =>
                        `block px-4 py-3 text-gray-700 hover:bg-gray-50 ${isActive ? "nav-link-active bg-blue-50" : ""
                        }`
                      }
                    >
                      {label}
                    </NavLink>
                  </li>
                ))}
              </ul>
              {/* CTA just below nav items */}
              <div className="mt-2 px-4 pt-2">
                <button
                  onClick={() => {
                    closeMobileMenu();
                    setShowModal(true);
                  }}
                  className="Navbar-CTA w-full text-center block border-none appearance-none bg-black text-white text-base py-3 px-4 rounded-lg"
                >
                  Get a Quote
                </button>
              </div>
            </nav>
          </div>
        </div>
      )}

      {showModal && <SignUpForm closeModal={() => setShowModal(false)} />}
    </>
  );
};

export default Navbar;
